import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/siteData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-xl font-bold transition-colors duration-300 ${
              isScrolled || !isHome ? 'text-primary-600' : 'text-white'
            }`}>
              {siteConfig.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`whitespace-nowrap text-sm font-medium transition-colors duration-200 ${
                  location.pathname === link.href
                    ? isScrolled || !isHome ? 'text-primary-600' : 'text-white font-semibold'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-600'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className={`whitespace-nowrap px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer ${
                isScrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              入口直达
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`whitespace-nowrap text-sm font-medium py-2 ${
                  location.pathname === link.href
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold text-center mt-2 cursor-pointer"
            >
              入口直达
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}